<template>
  <modal
    width="890px"
    speed="fast"
    noOutClose
    noClose
    maskNoClick
    :show="show"
    enter-active-class="fadeIn"
    leave-active-class="fadeOut"
    @update:show="close"
    class="quit-tip"
  >
    <div class="modal-header" slot="header">
      <p>侧面手机监控画面预览</p>
      <img class="close-icon" src="@/assets/images/icon-black-close.png" alt="close" @click="quit" />
    </div>
    <div slot="content">
      <div class="proctoring-preview-box">
        <div class="proctoring-example">
          <p class="preview-title">正确手机画面示例</p>
          <img
            src="@/assets/images/cellphone-example.png"
            alt="phone-example"
          />
        </div>
        <div class="proctoring-preview">
          <p class="preview-title">您的手机画面</p>
          <div id="preview-video-player" class="video-player"></div>
        </div>
      </div>
      <div class="proctoring-requires">
        <p>监考要求</p>
        <div class="require-list">
          <div class="require-item">
            <img src="@/assets/images/proctor-require-1.png" alt="require-1" />
            <p>画面中可见“考生头部”</p>
          </div>
          <div class="require-item">
            <img src="@/assets/images/proctor-require-2.png" alt="require-1" />
            <p>画面中可见“考生双手”</p>
          </div>
          <div class="require-item">
            <img src="@/assets/images/proctor-require-3.png" alt="require-1" />
            <p>画面中可见“考生电脑屏幕”</p>
          </div>
          <div class="require-item">
            <img src="@/assets/images/proctor-require-4.png" alt="require-1" />
            <p>画面中可见“考生桌面和大部分考试环境”</p>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer">
      <button class="blue-btn" @click="handlePass">
        我已满足监考要求，关闭预览
      </button>
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal'
export default {
  components: {
    Modal
  },
  data() {
    return {
      show: false
    }
  },
  methods: {
    close() {
      this.show = false
      this.$emit('close')
    },
    quit() {
      this.show = false
      this.$emit('quit')
    },
    handlePass() {
      this.$emit('preview-pass')
      this.close()
    },
    open(stream) {
      this.show = true
      setTimeout(() => {
        stream.play('preview-video-player')
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .modal-head {
  padding: 16px 20px;
  border-bottom: 1px solid #f1f1f1;
}
.white-btn {
  @include cancel-btn(96px, 36px, 14px, 4px);
  margin-right: 20px;
  margin-bottom: 10px;
}
.blue-btn {
  /* @include theme-fill-btn(96px, 36px, 14px, 4px); */
  padding: 12px 18px;
  border-radius: 4px;
  background: linear-gradient( 96deg, #329DFC 0%, #397EFD 100%);
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
.blue-btn:hover {
  background-color: #3a4cbf;
}
.blue-btn:active {
  background-color: #2e3a9c;
}
.text {
  font-size: 16px;
  margin: 20px 0 0 0;
}
.proctoring-preview-box {
  display: flex;
  justify-content: space-between;
  padding: 0 12px;
}
.proctoring-example {
  width: 400px;
  height: 275px;
  background-color: #f1f3f7;
  border-radius: 8px;
  border: 1px solid #f1f3f7;
  overflow: hidden;
  img {
    width: 400px;
    display: block;
  }
}
.preview-title {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding: 12px;
}
.proctoring-preview {
  width: 400px;
  height: 275px;
  background-color: #fceeed;
  border-radius: 8px;
  border: 1px solid #fceeed;
  overflow: hidden;
  .video-player {
    background-color: #000000;
    height: 223px;
  }
}
.proctoring-requires {
  width: 100%;
  margin-top: 12px;
  & > p {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    padding: 12px;
  }
  .require-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 130px;
    .require-item {
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      img {
        width: 130px;
        height: 98px;
        display: block;
        border: 1px solid #f1f3f9;
      }
      p {
        margin-top: 5px;
        font-size: 11px;
        color: #272748;
      }
    }
  }
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .close-icon {
    cursor: pointer;
    height: 16px;
    width: 16px;
  }
}
</style>
